import { useLayoutEffect, useState } from 'react'

import { useSettingsStore } from '~/stores/settings'

export const IS_VOICE_SUPPORTED = 'speechSynthesis' in window

const getVoice = (langCode: string) => speechSynthesis.getVoices().find(voice => voice.lang.startsWith(langCode))

/**
 * Returns the voice for the given language code.
 * If the voice is not supported, returns null.
 */
export const useVoice = (langCode: string) => {
  const [voice, setVoice] = useState<SpeechSynthesisVoice | undefined | null>(() =>
    IS_VOICE_SUPPORTED ? getVoice(langCode) : null,
  )
  const setVoiceAvailable = useSettingsStore(state => state.setVoiceAvailable)

  useLayoutEffect(() => {
    if (!IS_VOICE_SUPPORTED) return

    const onVoicesChangedHandler = () => {
      const langVoice = getVoice(langCode)
      setVoice(langVoice)
      setVoiceAvailable(langCode, !!langVoice)
    }

    speechSynthesis.addEventListener('voiceschanged', onVoicesChangedHandler)

    return () => speechSynthesis.removeEventListener('voiceschanged', onVoicesChangedHandler)
  }, [langCode, setVoiceAvailable])

  return voice
}
